import { Status } from "@budb/status";
import { ConditionallyRender } from "@gazebo/nextjs";
import { HideInProd } from "@gazebo/release";
import { useNotebookStore } from "@store";
import { NoteStore } from "@store/NoteStore";
import { SearchStore } from "@store/SearchStore";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import React, { useMemo, useState } from "react";
import { GardenEditor } from "./GardenEditor";
import {
  BasicInteraction,
  InteractionProvider
} from "./GardenEditor/interactions";

export const GardenNote: React.FC<{ note: NoteStore }> = observer(
  ({ note }) => {
    const router = useRouter();
    const notebook = useNotebookStore();
    const search = useMemo(() => new SearchStore(notebook), [notebook]);
    const interactionProvider = useMemo(
      () => new BasicInteraction(router, notebook),
      [router, notebook]
    );

    const [showCode, setShowCode] = useState(false);
    const [showMarkdown, setShowMarkdown] = useState(false);

    return (
      <div>
        <div className="note-head">
          <h1 className="title is-size-1">{note.data.title}</h1>
          <h2 className="subtitle is-size-6 has-text-weight-light opacity-half">
            {note.data.path.map((x) => (
              <span key={x}>{x}</span>
            ))}
            {""}/{note.id}.md
          </h2>
        </div>
        <HideInProd>
          <div className="buttons">
            <button
              className="button is-small"
              onClick={() => setShowCode((x) => !x)}
            >
              Toggle Code
            </button>
            <button
              className="button is-small"
              onClick={() => setShowMarkdown((x) => !x)}
            >
              Toggle Markdown
            </button>
          </div>
        </HideInProd>
        <div className="tags">
          {note.references.map((r) => (
            <span className="tag" key={r}>
              {r}
            </span>
          ))}
        </div>
        <ConditionallyRender client>
          <div className="columns">
            <div className="column">
              {(note.slate.status !== Status.READY)
                ? <p>Loading... {console.log('no ready!')}</p>
                : <>
                  <InteractionProvider value={interactionProvider}>
                    <GardenEditor key={note.id} note={note} searchStore={search} />
                    <div>
                      {note.externalBlocks.map((block) => {
                        return (
                          <>
                            {block.id}
                            <br />
                            {/* <pre>{JSON.stringify(block.data, undefined, 2)}</pre> */}
                          </>
                        );
                      })}
                    </div>
                    {/* <div>
                  {note.referencedBy.map(other => {
                    return <span key={other.id} className="tag">
                    {other.id}
                    </span>
                  })}
                </div> */}
                    {/* <div>
                  {note.referencedBy.map(other => {
                    return <React.Fragment key={other.id}>
                    {other.blocksReferencing(note.id).map(block => {
                      return <div className="block"><pre>{JSON.stringify(block, undefined, 2)}</pre></div>
                    })}
                    </React.Fragment>
                  })}
                </div> */}
                  </InteractionProvider>
                </>
              }
            </div>
            <HideInProd>
              {/* {true && (
                <div className="column is-5">
                  <p>{note.slate.isReady ? 'isReady' : 'notReady'}</p>
                  {note.slate.blocks.map(x => (
                    <div key={x.id} onClick={() => x.optimism.refresh()}>{JSON.stringify(x.slateContent, undefined, 2)}</div>
                  ))}
                </div>
              )} */}
              {showCode && (
                <div className="column is-5">
                  <h2>Content</h2>
                  <pre>{JSON.stringify(note.data, undefined, 2)}</pre>
                  <h2>Slate Content</h2>
                  <pre>{JSON.stringify(note.slate.content, undefined, 2)}</pre>
                </div>
              )}
              {showMarkdown && (
                <div className="column is-6">
                  <pre>{note.asMarkdown}</pre>
                </div>
              )}
            </HideInProd>
          </div>
        </ConditionallyRender>
      </div>
    );
  }
);
